import { Component, OnInit, Input } from '@angular/core';
import { IBilling, IInvoice } from '../../../interfaces/graph-types';
import { Observable, Subscription } from 'rxjs';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { OrganizationService } from '../../../services/organization.service';
import { BillingService } from '../../../services/billing.service';
import { ModalUpdateCardComponent } from '../../modals/update-card/modal-update-card.component';

@Component({
  selector: 'billing',
  template: require('./billing.component.pug'),
  styles: [require('./billing.component.css').toString()],
})
export class BillingComponent implements OnInit {
  @Input()
  orgId: string;

  invoices$: Observable<IInvoice[]>;
  bsModalRef: BsModalRef;

  subBilling: Subscription = null;
  loadingBilling: boolean = false;
  billing: IBilling = null;
  subReason: Subscription = null;

  // -------------------------------------------------------------------
  constructor(
    private billingService: BillingService,
    private organizationService: OrganizationService,
    private modalService: BsModalService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.checkBilling();
    this.invoices$ = this.organizationService.invoices(this.orgId);
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.subBilling) {
      this.subBilling.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  changeCard() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      orgId: this.orgId,
    };
    this.bsModalRef = this.modalService.show(ModalUpdateCardComponent, options);
    this.bsModalRef.content.closeBtnName = 'Close';

    this.subReason = this.bsModalRef.content.reason.subscribe(res => {
      if (res) {
        // card updated?
        this.checkBilling();
      }
    });
  }

  // -------------------------------------------------------------------
  checkBilling() {
    this.loadingBilling = true;
    if (this.subBilling) {
      this.subBilling.unsubscribe();
    }
    this.subBilling = this.organizationService
      .billing(this.orgId)
      .subscribe(response => {
        this.billing = response.billing;
        this.loadingBilling = false;
      });
  }

  // -------------------------------------------------------------------
  changeDetected(
    data: any,
    newValue: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.billingService.setField(
      this.billing.id,
      data,
      newValue,
      () => {
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }
}
